var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgWrench = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 21,
  height: 20,
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M14.299 2.523a4.166 4.166 0 0 0-4.264 5.858.833.833 0 0 1-.17.933l-5.759 5.759a.935.935 0 0 0 1.322 1.321l5.758-5.758a.833.833 0 0 1 .933-.17 4.167 4.167 0 0 0 5.858-4.264l-2.143 2.143a1.667 1.667 0 0 1-2.334 0l-.005-.006L12.155 7a1.667 1.667 0 0 1 0-2.333l.006-.006L14.3 2.523ZM12.785.925a5.833 5.833 0 0 1 3.45.424.834.834 0 0 1 .246 1.349l-3.135 3.135 1.321 1.322 3.136-3.136a.833.833 0 0 1 1.348.246A5.834 5.834 0 0 1 11.98 12.2l-5.374 5.373a2.601 2.601 0 1 1-3.678-3.679L8.3 8.521A5.833 5.833 0 0 1 12.785.925Z",
  clipRule: "evenodd"
})));
SvgWrench.viewBox = null;
const ForwardRef = /*#__PURE__*/forwardRef(SvgWrench);
export default ForwardRef;